import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Drawer           from '@material-ui/core/Drawer';
import List             from '@material-ui/core/List';
import ListItem         from '@material-ui/core/ListItem';
import ListItemText     from '@material-ui/core/ListItemText';
import CssBaseline      from '@material-ui/core/CssBaseline';
import Typography       from '@material-ui/core/Typography';
import Card             from '@material-ui/core/Card';
import CardContent      from '@material-ui/core/CardContent';
import ColAtm           from "../../../../atomic/Col/Col";
import 'react-circular-progressbar/dist/styles.css';
import {Link} from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import {CircularProgressbar} from "react-circular-progressbar";
import Divider from "@material-ui/core/Divider";
import ButtonAtm from "../../../../atomic/Button/Button";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import StatusBox from "./StatusBox";
import {getDashboardOffer} from "../../../../../redux/actions/Offer/OfferDashboard/dasboardActions";
import Grid from "@material-ui/core/Grid";
import {propertyProducts} from "../../../../../redux/actions/propertyProductsActions";
import {isDefined} from "../../../../../utils";
import NotAllowedPage from "../../../Global/NotAllowedPage/NotAllowedPage";
import {NETWORK_COMPETITOR, NOT_ALLOWED_DASHBOARD_SHORT, REPUTATION_MANAGEMENT, NETWORK_COMPETITOR_DASH} from "../../../../../constants/appUrls.constants";
import Charts from "../../../Global/Charts";
import { Box } from '@material-ui/core';
import { getProperty } from '../../../../../utils';

import DashboardBottomActions from "../../../../molecules/DashboardBottomActions/DashboardBottomActions";
let t=null

const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

class OfferDashboardData extends Component{

    constructor(props) {
        super(props);
        t = props.t;
    }

    render(){

        const dashboard = this.props.property_dashboard;
        const leftDrawer = this.props.left_drawer;
        const fetching = this.props.fetching
        const dashboardOffer = this.props.dashboardOfferReducer


        const allowedPage = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        const propertyId = Number(getProperty());

        function Dashboard(props) {
            const classes = useStyles();

            function Sidebar(props) {
                const [isExpanded, setIsExpanded] = React.useState(false);
                const hoverTimeoutRef = React.useRef(null);
                const isNavigatingRef = React.useRef(false);

                const handleMouseEnter = () => {
                    if (isNavigatingRef.current) return;
                    
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    setIsExpanded(true);
                };

                const handleMouseLeave = () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    hoverTimeoutRef.current = setTimeout(() => {
                        if (!isNavigatingRef.current) {
                            setIsExpanded(false);
                        }
                    }, 100);
                };

                const handleLinkClick = (e) => {
                    isNavigatingRef.current = true;
                    
                    const currentExpanded = isExpanded;
                    
                    setTimeout(() => {
                        isNavigatingRef.current = false;
                        setIsExpanded(currentExpanded);
                    }, 500);
                };

                // Cleanup
                React.useEffect(() => {
                    return () => {
                        if (hoverTimeoutRef.current) {
                            clearTimeout(hoverTimeoutRef.current);
                        }
                    };
                }, []);

                const sidebar = (
                    <div className={classes.root}>
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper + " left-sidebar",
                            }}
                            PaperProps={{
                                onMouseEnter: handleMouseEnter,
                                onMouseLeave: handleMouseLeave,
                                style: {
                                    width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                                },
                            }}
                        >
                            <List className={classes.sidebarList}>
                                {props.siderbarItems.map((post, key) => (
                                    <React.Fragment key={key}>
                                        <Link 
                                            to={post.link} 
                                            className={classes.sidebarLink}
                                            onClick={handleLinkClick}
                                        >
                                            <Box 
                                                className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                            >
                                                <Box className={classes.sidebarIconWrapper}>
                                                    <i 
                                                        className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                    />
                                                </Box>
                                                <Typography 
                                                    className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                                >
                                                    {post.text}
                                                </Typography>
                                            </Box>
                                        </Link>
                                    </React.Fragment>
                                ))}
                            </List>
                            {/* Panel + Site Ayarları: logonun üstünde */}
                            <DashboardBottomActions />

                            <Box className={classes.chartsWrapper}>
                                <Charts />
                            </Box>
                        </Drawer>
                    </div>
                );
                return (
                    <>
                        {sidebar}
                    </>
                );
            }

            const siderbarItems = [
                {id: 1, isActive: false, text: `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:"content"},
                {id: 4, isActive: false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? "web" : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#"},
                {id: 5, isActive: false, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? "booking-engine" : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#"},
                {id: 6, isActive: false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#"},
                {id: 3, isActive: true, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? "offer" : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#"},
                {id: 2, isActive: false, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? "network" : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#"},
                {id: 7, isActive: false, text: (
                    <>
                        {t('enw-input-competitor')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH },
                {id: 8, isActive: false, text: (
                        <>
                            {t('enw-reputation_management-title')}
                            <span className="newBadge">{t('enw-new_title')}</span>
                        </>
                ), icon: 'fas fa-comments-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
            ];

            const [open] = React.useState(false);
            return (
                <Grid container className="payment-dashboard">
                    <Grid item md={1} className="m-none" style={{ height: 'fit-content'}}>
                        <Sidebar siderbarItems={siderbarItems} />
                        <Drawer
                            className={classes.leftMenu}
                            variant="persistent"
                            anchor="left"
                            open={open}
                            classes={{
                                paper: classes.leftMenuPaper,
                            }}
                        >
                            <div className={classes.drawerHeader}>
                                <IconButton className="drawer-back-button">
                                    <i className="fas fa-arrow-left" />
                                </IconButton>
                            </div>
                            <ColAtm className="progress-bar-content">
                                <CircularProgressbar
                                    className="profile-rate"
                                    counterClockwise
                                />
                                <p className="profile-power">
                                    Profile Rate
                                    <br/>
                                    <span className="bold-black-text"></span>
                                </p>
                                <Card className="drawer-info">
                                    <CardContent>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            You can increase the profile strength by starting to fill the Photo and amenties fields.
                                        </Typography>
                                    </CardContent>
                                </Card>
                                <Divider />
                                <ColAtm>
                                    <ColAtm>
                                        <Typography className="bold-black-text">
                                            What are the benefits of increasing Profile Strength?
                                        </Typography>
                                    </ColAtm>
                                    <ColAtm className="hints-padding">
                                        <ColAtm md={3} xl={2}>
                                            <i className="far fa-lightbulb-on hints-icon" />
                                        </ColAtm>
                                        <ColAtm className="hints-border" md={9} xl={10}>
                                            <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                Completing your property's general informations
                                            </Typography>
                                        </ColAtm>
                                    </ColAtm>
                                    <Divider />
                                    <ColAtm className="hints-padding">
                                        <ColAtm md={3} xl={2}>
                                            <i className="far fa-lightbulb-on hints-icon" />
                                        </ColAtm>
                                        <ColAtm className="hints-border" md={9} xl={10}>
                                            <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                Updating room details.
                                            </Typography>
                                        </ColAtm>
                                    </ColAtm>
                                    <Divider />
                                    <ColAtm className="hints-padding">
                                        <ColAtm md={3} xl={2}>
                                            <i className="far fa-lightbulb-on hints-icon" />
                                        </ColAtm>
                                        <ColAtm className="hints-border" md={9} xl={10}>
                                            <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                Upload your property's photos
                                            </Typography>
                                        </ColAtm>
                                    </ColAtm>
                                    <Divider />
                                    <ButtonAtm className="photoUploadButton all-hints-button" buttontext={'All View'} fullwidth={true} />

                                </ColAtm>
                            </ColAtm>
                        </Drawer>
                    </Grid>
                    <Grid item xs={12} className="m-auto web-dashboard">
                        <div>
                            <CssBaseline />
                            {
                                isDefined(allowedPage[0]) && !allowedPage[0].property_has_product ?
                                    <Grid item xs={12} lg={6} className="no-buy-product">
                                        <Card className="p-24">
                                            <NotAllowedPage />
                                        </Card>
                                    </Grid>
                                    :
                                    <StatusBox fetching={fetching} dashBoardOffer={dashboardOffer} />
                            }
                        </div>
                    </Grid>
                    <style>{`
                    @media (min-width: 767px) {
                        .rm-circular-progress {
                            position: relative !important;
                        }
                    }
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                `}</style>
                </Grid>
            );
        }
        return(
            <Dashboard dashboard={dashboard} leftDrawer={leftDrawer} propertyProductsReducer={this.props.propertyProductsReducer} />
        );
    }
}

const mapStateToProps = (props) => {
    return {
        dashboardOfferReducer : props.dashboardOfferReducer
    }
};

const mapDispatchToProps ={
    getDashboardOffer
};


export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(OfferDashboardData));
